import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formValueSelector } from 'redux-form';
import Form from '../../components/forms/OvmForm';
import { saveOvm, withRedirect } from '../../CroActions';
import { breadcrumbs } from '../../../../actions/appActions';

const selector = formValueSelector('ovmForm');

const mapStateToProps = (state, { params }) => ({
  breadcrumbsItems: [{ label: 'Podpůrné orgány' }, { label: 'Nový podpůrný orgán' }],
  loginData: { ic: selector(state, 'ic') },
  allowDatabox: selector(state, 'allowDatabox'),
  allowBasic: selector(state, 'allowBasic'),
  isNew: true,
});

const onSubmit = (url) => withRedirect(saveOvm(url), `${url}/podpurne-organy`);

const mapDispatchToProps = (dispatch, { auth }) => ({
  ...bindActionCreators({ onSubmit: onSubmit(auth.startUrl), breadcrumbs }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
